<template>
<div>
    <div class="boxes">
        <div class="columns is-multiline" style="margin-bottom:0;">
            <div class="column is-6">
                <div class="title-and-icon-info" style="margin-top: 0px !important; margin-bottom: 0px !important;">
                    <div class="icon-info"><font-awesome-icon :icon="['fas', 'cloud']"/></div>
                    <div class="title-info">Provider Snapshots</div>
                </div>
                <!-- <div class="accounts-title active-title"><font-awesome-icon icon="cloud"/> Cloud accounts</div> -->
            </div>
            <div class="column is-6 has-text-right">
                <div @click="addAccount" class="button is-info">
                    <font-awesome-icon icon="plus-circle"/><span class="add-account-button-text">Connect cloud account</span>
                </div>
            </div>
            <!-- <div v-if="serviceDisabled" class="column is-full">
                <div class="notification is-danger" style="font-size: 13px; margin-bottom: 15px;">Weap.io is not taking care of your snapshots anymore. Subscribe to <router-link :to="{ name: 'subscriptionSettings' }">a plan</router-link> if you want to have worry-free backups of your cloud servers.</div>
            </div>
            <div v-if="serviceAboutToBeDisabled" class="column is-full">
                <div class="notification is-danger" style="font-size: 13px; margin-bottom: 15px;">Your Weap.io subscription was cancelled. Starting from <strong>{{ user.subscription_cancellation_effective_from }}</strong> it will be effective and Weap.io will stop taking care of your backups. If you want to continue using Weap.io, subscribe to <router-link :to="{ name: 'subscriptionSettings' }">a plan</router-link>.</div>
            </div>
            <div v-if="serviceInTrial" class="column is-full">
                <div class="notification is-info" style="font-size: 13px; margin-bottom: 15px;">Weap.io will take care of your snapshots until <strong>{{ user.trial_expires_at }} UTC</strong>. Subscribe to <router-link :to="{ name: 'subscriptionSettings' }">a plan</router-link> if you want to continue using Weap.io after the free trial.</div>
            </div>
            <div v-if="servicePastDue" class="column is-full">
                <div class="notification is-danger" style="font-size: 13px; margin-bottom: 15px;">We could not process your payment. If we still can't process it until <strong>2019-12-24</strong>, your susbcription will be cancelled automatically and Weap.io will stop taking care of your backups. Make sure to have enough funds on your account. Alternatively you can update your payment details <router-link :to="{ name: 'subscriptionSettings' }">here</router-link>.</div>
            </div> -->

        </div>

        <div v-for="account in accounts.data" v-bind:key="account.id">
            <account-widget :account="account"></account-widget>
        </div>
    </div>
    <add-account></add-account>
    <account-default-backup-settings></account-default-backup-settings>
    <cloudlet-details></cloudlet-details>
    <no-account-connected v-if="!hasAccounts" :margin-top="noAccountConnectedMarginTop"></no-account-connected>
</div>
</template>

<script>
import Api from '@/api';
import AccountWidget from '@/components/Accounts/Widget.vue';
import AddAccount from '@/components/Accounts/Add.vue';
import AccountDefaultBackupSettings from '@/components/Accounts/DefaultBackupSettings.vue';
import CloudletDetails from '@/components/Cloudlets/Details.vue';
import NoAccountConnected from '@/components/Dashboard/NoAccountConnected.vue';

export default {
    components: {
        AccountWidget,
        AddAccount,
        AccountDefaultBackupSettings,
        CloudletDetails,
        NoAccountConnected,
    },

    props: ['accountId'],

    data() {
        return {
            accountsFetchedOnce: false,
            accounts: [],
            user: null,
        }
    },

    mounted() {
        this.getAccounts();
        this.getUser();
        this.listenEvents();
    },

    methods: {
        addAccount() {
            Event.$emit('showAddAccount');
        },

        getAccounts(callback) {
            Api().get('accounts')
                .then(response => {
                    this.accounts = response.data;
                    this.accountsFetchedOnce = true;
                    if (typeof callback === 'function') {
                        callback();
                    }
                })
                .catch(error => {
                    //
                })
                .finally(() => {
                    //
                });
        },

        getUser() {
            Api().get('users/current')
                .then((response) => {
                    this.user = response.data.data;
                });
        },

        listenEvents() {
            Event.$on('refreshAccounts', (callback) => {
                this.getAccounts(callback);
            });
        },
    },

    computed: {
        hasAccounts() {
            if (!this.accountsFetchedOnce) {
                return true;
            }

            return this.accounts.data.length > 0;
        },

        serviceDisabled() {
            if (!this.user || typeof this.user.service_disabled === 'undefined') {
                return false;
            }

            return this.user.service_disabled;
        },

        serviceAboutToBeDisabled() {
            if (!this.user || typeof this.user.subscription_cancelled === 'undefined' || typeof this.user.subscription_cancellation_is_effective === 'undefined') {
                return false;
            }

            return this.user.subscription_cancelled && !this.user.subscription_cancellation_is_effective;
        },

        serviceInTrial() {
            if (!this.user || typeof this.user.in_trial === 'undefined') {
                return false;
            }

            return this.user.in_trial && !this.user.subscription_active && !this.user.subscription_cancelled;
        },

        servicePastDue() {
            if (!this.user || typeof this.user.subscription_past_due === 'undefined') {
                return false;
            }

            return this.user.subscription_past_due;
        },

        noAccountConnectedMarginTop() {
            if (this.serviceDisabled || this.serviceAboutToBeDisabled || this.serviceInTrial || this.servicePastDue) {
                return 0;
            }

            return 20;
        },
    },
}
</script>

<style>
.slide-enter-active {
    -moz-transition-duration: 0.3s;
     -webkit-transition-duration: 0.3s;
     -o-transition-duration: 0.3s;
     transition-duration: 0.3s;
     -moz-transition-timing-function: ease-in;
     -webkit-transition-timing-function: ease-in;
     -o-transition-timing-function: ease-in;
     transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 500px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}
</style>
